<div class="rlp-page">
  <h1 class="rlp-title">Register a License Plate</h1>
  <p class="rlp-intro">Add a plate to your account so your parking is recognized automatically.</p>

  @if (error()) {
    <div class="rlp-error">{{ error() }}</div>
  }

  <form class="rlp-form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">

    <!-- Country -->
    <div class="rlp-field">
      <label class="rlp-label" for="country">Country of registration</label>
      <select id="country" class="rlp-select" formControlName="country">
        @for (c of countries; track c.code) {
          <option [value]="c.code">{{ c.code }}</option>
        }
      </select>
    </div>

    <!-- Plate -->
    <div class="rlp-field">
      <label class="rlp-label" for="plate">License plate</label>
      <app-plate editable [euBand]="selectedCountry().euBand" [countryCode]="selectedCountryCode()">
        <input id="plate" type="text" class="rlp-plate-field" formControlName="plate"
               (input)="onPlateFieldInput($event, 'plate')" [maxlength]="maxPlateLength"
               autocomplete="off" spellcheck="false" placeholder="LL123AB" />
      </app-plate>
      @if (registerForm.get('plate')?.touched && registerForm.get('plate')?.invalid) {
        <span class="rlp-field-error">Please enter a valid license plate.</span>
      }
    </div>

    <!-- Plate repeat -->
    <div class="rlp-field">
      <label class="rlp-label" for="plateRepeat">Repeat license plate</label>
      <app-plate editable [euBand]="selectedCountry().euBand" [countryCode]="selectedCountryCode()">
        <input id="plateRepeat" type="text" class="rlp-plate-field" formControlName="plateRepeat"
               (input)="onPlateFieldInput($event, 'plateRepeat')" [maxlength]="maxPlateLength"
               autocomplete="off" spellcheck="false" />
      </app-plate>
      @if (platesMismatch) {
        <span class="rlp-field-error">The license plates do not match.</span>
      }
    </div>

    <!-- Type -->
    <div class="rlp-field">
      <label class="rlp-label" for="type">Plate type</label>
      <select id="type" class="rlp-select" formControlName="type">
        @for (t of plateTypes; track t.value) {
          <option [value]="t.value">{{ t.label }}</option>
        }
      </select>
    </div>

    <!-- Preview -->
    <div class="rlp-field">
      <span class="rlp-label">Preview</span>
      <app-plate size="lg" [number]="plateValue()" [euBand]="selectedCountry().euBand"
                 [countryCode]="selectedCountryCode()" [region]="plateRegion()"
                 [regionSeparator]="selectedCountry().regionSeparator" placeholder="· · ·" />
    </div>

    <!-- Actions -->
    <div class="rlp-actions">
      <jjames-button variant="outline" (clicked)="onBack()" [disabled]="submitting()">Back</jjames-button>
      <jjames-button variant="primary" (clicked)="onSubmit()" [loading]="submitting()">Register</jjames-button>
    </div>

  </form>
</div>
